<template>
<div class="bg-img">
  <div style="height:80px;line-height:90px;text-align: center;color: #FFFFFF;font-size: 22px;letter-spacing: 2px">数据详情</div>
  <div style="height: 55px;margin-left: 20px">
    <div v-for="item in menuArr" :key="item.id" :class="selectId === item.id ? 'select-tab1' : 'select-tab2'" @click="changeTab(item.id)"><span>{{item.name}}</span></div>
  </div>
  <div v-if="selectId === 1" style="height: 515px;margin: 0 20px">
    <el-row>
      <el-col :span="6">
        <div style="height: 140px">
          <el-col :span="9">
            <div v-if="personHealthRow.photo_url !== ''" class="img-person">
              <img :src="personHealthRow.photo_url">
            </div>
            <div v-else class="img-person">
              <img v-if="personHealthRow.sex === '0'" src="static/nv.png">
              <img v-else src="static/nan.png">
            </div>
          </el-col>
          <el-col :span="15">
            <div class="line-info">
              <img v-if="personHealthRow.sex === '0'" style="vertical-align: middle" src="../../../assets/health/nv.png">
              <img v-if="personHealthRow.sex === '1'" style="vertical-align: middle" src="../../../assets/health/nan.png">
              <span> {{ personHealthRow.person_name }} · {{getAgeDesc(personHealthRow.birthday)}}</span>
            </div>
            <div class="line-info"><span style="font-size: 14px;color: #999999">身高: </span><span> {{ personHealth.shengao }}cm</span></div>
            <div class="line-info"><span style="font-size: 14px;color: #999999">体重: </span><span> {{ personHealth.tizhong }}kg</span></div>
            <div class="line-info"><span style="font-size: 14px;color: #999999">血型: </span><span> {{ personHealth.xuexing }}</span></div>
          </el-col>
        </div>
        <div style="height: 40px;line-height: 40px;color: #FFFFFF;font-size: 22px;text-align: left"><span>基础疾病</span></div>
        <div style="height: 345px;overflow-y: auto;">
          <div class="base-disease" v-for="item in baseDiseaseArr" :key="item.id"><span>{{item.name}}</span></div>
        </div>
      </el-col>
      <el-col :span="18">
        <div style="margin: 0 15px">
          <div class="title-line">
            <div class="triangle"></div>
            <div class="triangle-title">健康预警</div>
          </div>
          <div class="six-list">
            <div v-if="typeIconList.length === 0" style="height: 80px;line-height: 80px;color: #FFFFFF;text-align: center;font-size: 20px">近期暂无测量健康信息。</div>
            <el-row>
              <el-col :span="4" v-for="(item, index) in typeIconList" :key="index">
                <div class="time-top"><span>{{ item.time }}</span></div>
                <div class="flex-box">
                  <div :class="item.isRed ? 'bor-r' : 'bor-b'">
                    <img :src="item.icon">
                  </div>
                  <div class="num-right">
                    <div class="top-text">{{ item.name }}</div>
                    <div class="bottom-text">
                      <span :style="{color: item.isRed ? '#BB3424' : '#34B8FF'}" v-if="item.name === '血压'">{{item.val1}} / {{item.val2}}</span>
                      <span v-else :style="{color: item.isRed ? '#BB3424' : '#34B8FF'}">{{item.val}}<span v-if="item.name === '体温'">℃</span></span>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="title-line">
            <div class="triangle"></div>
            <div class="triangle-title">健康评测</div>
          </div>
<!--          <div class="type-cnt">-->
<!--            <div class="type-list">-->
<!--              <span>测评更新于2021-11-26 17:24:41</span>-->
<!--            </div>-->
<!--            <div class="btn-type">立即测评</div>-->
<!--          </div>-->
          <div style="height: 20px"></div>
          <div class="health-list">
            <el-row>
              <el-col :span="18">
                <div class="line-health">
                  <div class="icon-left"><img src="static/health/icon/shenti.png"></div>
                  <div class="title-text">躯体健康</div>
                  <div class="progress-bar">
                    <div class="bg-progress">
                      <div style="width: 30%" class="red-progress">
                        <img class="progress-img" src="static/health/icon/red.png">
                      </div>
                    </div>
                  </div>
                  <div class="end-num"><span style="color: #FF5469">不健康</span></div>
                </div>
                <div class="line-health">
                  <div class="icon-left"><img src="static/health/icon/xinli.png"></div>
                  <div class="title-text">心理健康</div>
                  <div class="progress-bar">
                    <div class="bg-progress">
                      <div style="width: 60%" class="yellow-progress">
                        <img class="progress-img" src="static/health/icon/yellow.png">
                      </div>
                    </div>
                  </div>
                  <div class="end-num"><span style="color: #EBB342">基本健康</span></div>
                </div>
                <div class="line-health">
                  <div class="icon-left"><img src="static/health/icon/shehui.png"></div>
                  <div class="title-text">社会健康</div>
                  <div class="progress-bar">
                    <div class="bg-progress">
                      <div style="width: 80%" class="green-progress">
                        <img class="progress-img" src="static/health/icon/green.png">
                      </div>
                    </div>
                  </div>
                  <div class="end-num"><span style="color: #61CCA0">健康</span></div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="total-score">
                  <div style="height: 60px;line-height: 60px;font-size: 20px;color: #FFFFFF;text-align: center">总分</div>
                  <div style="height: 50px;text-align: center"><img src="static/health/icon/green.png"></div>
                  <div style="height: 60px;line-height: 60px;font-size: 20px;text-align: center"><span style="color: #61CCA0">健康</span></div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
  <div v-if="selectId === 2" style="height: 515px;">
    <history-list-show :healthObj="openHealthObj"></history-list-show>
  </div>
  <div v-if="selectId === 3" style="height: 515px;">
    <sleep-history :healthObj="openHealthObj"></sleep-history>
  </div>
  <div v-if="selectId === 4" style="height: 515px;">
    <sleep-report :healthObj="openHealthObj"></sleep-report>
  </div>
</div>
</template>

<script>
import historyListShow from './historyListShow'
import sleepHistory from './sleepHistory.vue'
import sleepReport from './sleepReport.vue'
export default {
  name: 'healthDetails',
  props: {
    openHealthObj: {
      type: Object,
      default: null
    }
  },
  components: {historyListShow, sleepHistory, sleepReport},
  data () {
    return {
      selectId: 1,
      menuArr: [
        {id: 1, name: '健康信息'},
        {id: 2, name: '历史曲线'},
        {id: 3, name: '睡眠记录'}
        // {id: 4, name: '睡眠报告'}
      ],
      personHealthRow: '',
      personHealth: {
        shengao: '-',
        tizhong: '-',
        xuexing: '-'
      },
      baseDiseaseArr: [
        {id: 1, name: '胃病'},
        {id: 2, name: '冠心病'},
        {id: 3, name: '慢性呼吸道疾病'}
      ],
      typeIconList: []
    }
  },
  created () {
    this.personHealthRow = this.openHealthObj.personHealthRow // 老人最新数据
    console.log(this.personHealthRow)
    this.getDataInfo()
  },
  methods: {
    changeTab (id) {
      this.selectId = id
    },
    getDataInfo () {
      // console.log(890, this.personHealthRow)
      let vm = this
      let personHealth = this.clone(this.personHealthRow.person_health_value)
      // let healthType = this.clone(this.openHealthObj.healthdatatype)
      let healthArr = []
      let xueya = {name: '血压', val1: '', val2: '', time: '', icon: '/static/health/icon/xueya_r.png', isRed: true}
      let shuimian = {name: '睡眠', val: '', val1: '', val2: '', time: '', icon: '/static/health/icon/shuimian_r.png', isRed: true}
      personHealth.forEach(item => {
        let obj = {name: '', val: '', time: '', isRed: true}
        if (item.keyName === '身高') {
          vm.personHealth.shengao = item.health_value
        } else if (item.keyName === '体重') {
          vm.personHealth.tizhong = item.health_value
        } else if (item.keyName === '血型') {
          vm.personHealth.xuexing = item.health_value
        } else if (item.keyName === '体温') {
          obj.name = item.keyName
          obj.val = item.health_value
          obj.time = item.create_time
          obj.icon = '/static/health/icon/tiwen_r.png'
          if (parseFloat(obj.val) >= 36 && parseFloat(obj.val) <= 37) {
            obj.icon = '/static/health/icon/tiwen_b.png'
            obj.isRed = false
          }
          healthArr.push(obj)
        } else if (item.keyName === '心率') {
          obj.name = item.keyName
          obj.val = item.health_value
          obj.time = item.create_time
          obj.icon = '/static/health/icon/xinlv_r.png'
          if (parseFloat(obj.val) >= 50 && parseFloat(obj.val) <= 80) {
            obj.icon = '/static/health/icon/xinlv_b.png'
            obj.isRed = false
          }
          healthArr.push(obj)
        } else if (item.keyName === '血氧') {
          obj.name = item.keyName
          obj.val = item.health_value
          obj.time = item.create_time
          obj.icon = '/static/health/icon/xueyang_r.png'
          if (parseFloat(obj.val) >= 90) {
            obj.icon = '/static/health/icon/xueyang_b.png'
            obj.isRed = false
          }
          healthArr.push(obj)
        } else if (item.keyName === '血糖') {
          obj.name = item.keyName
          obj.val = item.health_value
          obj.time = item.create_time
          obj.icon = '/static/health/icon/xuetang_r.png'
          if (parseFloat(obj.val) >= 3.9 && parseFloat(obj.val) <= 6.1) {
            obj.icon = '/static/health/icon/xuetang_b.png'
            obj.isRed = false
          }
          healthArr.push(obj)
        } else if (item.keyName === '血压-高压') {
          xueya.val1 = item.health_value
          if (parseFloat(obj.val1) <= 130) {
            xueya.icon = '/static/health/icon/xueya_b.png'
            xueya.isRed = false
          }
          xueya.time = item.create_time
        } else if (item.keyName === '血压-低压') {
          xueya.val2 = item.health_value
          if (parseFloat(obj.val1) <= 80) {
            xueya.icon = '/static/health/icon/xueya_b.png'
            xueya.isRed = false
          }
        } else if (item.keyName === '睡眠质量-深睡') {
          shuimian.val1 = item.health_value
          shuimian.time = item.create_time
        } else if (item.keyName === '睡眠质量-浅睡') {
          shuimian.val2 = item.health_value
        }
      })
      if (shuimian.val1 !== '' && shuimian.val2 !== '') {
        shuimian.val = parseFloat(shuimian.val1) + parseFloat(shuimian.val2)
        if (shuimian.val > 4.5) {
          shuimian.icon = '/static/health/icon/shuimian_b.png'
          shuimian.isRed = false
        }
        healthArr.push(shuimian)
      }
      if (xueya.val1 !== '' && xueya.val2 !== '') {
        healthArr.push(xueya)
      }
      this.typeIconList = healthArr
      // console.log(healthArr)
    },
    getAgeDesc (birthDate) {
      let result = ''
      let age = this.util.getAgeByBirth(birthDate)
      if (age === '') {
        result = '--'
      } else {
        result = age + '岁'
      }
      return result
    }
  }
}
</script>

<style scoped>
.bg-img{
  height: 700px;
  background: url("../../../assets/health/open_bg.png") no-repeat;
  background-size: 100% 100%;
}
.select-tab1{
  color: #FFFFFF;
  float: left;
  width: 180px;
  height: 33px;
  line-height: 33px;
  text-align: center;
  font-size: 18px;
  background: url("../../../assets/health/tab_icon1.png") no-repeat;
  background-size: 100% 100%;
}
.select-tab2{
  color: #29F1FA;
  float: left;
  width: 180px;
  height: 33px;
  line-height: 33px;
  text-align: center;
  font-size: 18px;
  background: url("../../../assets/health/tab_icon2.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}
.img-person{
  width: 105px;
  height: 130px;
  /*background-color: #87d5f5;*/
}
.img-person img{
  width: 105px;
  height: 130px;
}
.line-info{
  margin-left: 5px;
  color: #FFFFFF;
  height: 32px;
  line-height: 32px;
  font-size: 18px;
  overflow: hidden;
}
.base-disease{
  float: left;
  margin: 5px;
  min-width: 110px;
  padding: 0 10px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #253861;
  border-radius: 5px 5px 5px 5px;
  color: #FFFFFF;
  font-size: 18px;
  letter-spacing: 1px;
}
.title-line{
  border-left: 4px solid #1B7EF2;
  height: 40px;
  background: rgba(24, 162, 242, 0.2);
  border-radius: 0px 0px 0px 0px;
}
.triangle{
  float: left;
  width: 0;
  height: 0;
  border-top: 7px solid transparent;
  border-right: 7px solid transparent;
  border-left: 7px solid #29F1FA;
  border-bottom: 7px solid transparent;
  margin-top: 13px;
  margin-left: 15px;
}
.triangle-title{
  float: left;
  height: 40px;
  line-height: 40px;
  /*margin-left: 10px;*/
  font-size: 18px;
  letter-spacing: 2px;
  color: #FFFFFF;
}
.six-list{
  height: 140px;
}
.time-top{
  padding-top: 20px;
  height: 20px;
  font-size: 14px;
  color: #FFFFFF;
}
.flex-box{
  padding: 0px 0 20px;
  width: 100%;
  height: 80px;
  display: flex;
}
.bor-b{
  margin-top: 8px;
  width: 45px;
  height: 45px;
  padding: 5px;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #34B8FF;
}
.bor-r{
  margin-top: 8px;
  width: 45px;
  height: 45px;
  padding: 5px;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #BB3424;
}
.num-right{
  flex: 1;
  height: 80px;
  padding: 0 10px;
  box-sizing: border-box;
}
.top-text{
  height: 40px;
  font-size: 24px;
  color: #FFFFFF;
}
.bottom-text{
  font-size: 18px;
  height: 30px;
}
.type-cnt{
  height: 34px;
  margin: 20px 0;
  display: flex;
}
.type-list{
  height: 34px;
  line-height: 34px;
  font-size: 16px;
  color: #FFFFFF;
  flex: 1;
}
.btn-type{
  width: 100px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  letter-spacing: 2px;
  color: #FFFFFF;
  font-size: 18px;
  background: #34B8FF;
  border-radius: 4px 4px 4px 4px;
  cursor: pointer;
}
.health-list{
  height: 250px;
}
.line-health{
  height: 45px;
  margin: 25px 0;
  display: flex;
}
.icon-left{
  width: 45px;
  height: 45px;
}
.title-text{
  width: 120px;
  height: 45px;
  line-height: 45px;
  font-size: 22px;
  color: #FFFFFF;
  text-align: center;
  letter-spacing: 1px;
}
.progress-bar{
  width: 400px;
  height: 45px;
}
.bg-progress{
  margin-top: 15px;
  width: 400px;
  height: 15px;
  background: #253861;
  border-radius: 7px 7px 7px 7px;
}
.red-progress{
  text-align: right;
  margin-top: 15px;
  height: 15px;
  background: linear-gradient( -90deg, #FF5469 0%, #FFFFFF 100%);
  border-radius: 7px 7px 7px 7px;
}
.yellow-progress{
  text-align: right;
  margin-top: 15px;
  height: 15px;
  background: linear-gradient( -90deg, #EBB342 0%, #FFFFFF 100%);
  border-radius: 7px 7px 7px 7px;
}
.green-progress{
  text-align: right;
  margin-top: 15px;
  height: 15px;
  background: linear-gradient( -90deg, #61CCA0 0%, #FFFFFF 100%);
  border-radius: 7px 7px 7px 7px;
}
.progress-img{
  margin-top: -17px;
  margin-right: -10px;
}
.end-num{
  flex: 1;
  height: 45px;
  line-height: 45px;
  font-size: 20px;
  margin-left: 20px;
}
.total-score{
  margin-top: 33px;
  width: 120px;
  height: 170px;
  background: #253861;
  border-radius: 4px 4px 4px 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/healthDetails.vue